import React from "react";
//styles
import "./skelton.scss";
// services
import ClipLoader from "react-spinners/ClipLoader";
import MoonLoader from "react-spinners/MoonLoader";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import ImageLoader from "./ImageLoader";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    background: "#fff",
  },
}));

export const DigiLoader = () => {
  return <div className="loader"></div>;
};

export const Loader = ({ loading, className }) => {
  return (
    <div className={className}>
      <ClipLoader color={"#007dc5"} loading={loading} size={40} />
    </div>
  );
};

export const UploadLoader = ({ loading, className }) => {
  return (
    <MoonLoader
      color={"#007dc5"}
      loading={loading}
      size={34}
      speedMultiplier={0.8}
    />
  );
};

export const CommonLoader = ({ loading, className }) => {
  return (
    <>
      <div className="custom-modal-overlay">
        <div className="custom-modal">
          <UploadLoader />
          {/* <ImageLoader/> */}
        </div>
      </div>
    </>
  );
};




export const InitialLoader = () => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
